var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("I am a back door")]),_c('DeleteEnityWdiget',{attrs:{"entityName":'legal-person'}}),_c('DeleteEnityWdiget',{attrs:{"entityName":'natural-person'}}),_c('DeleteEnityWdiget',{attrs:{"entityName":'sp-person'}}),_c('DeleteEnityWdiget',{attrs:{"entityName":'asset'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }